import React, { useState } from "react";
import { useTable } from "react-table";
import { SetInfo } from "../utils/SetInfo";

import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";


export function CreateTableForReferenceSelect({
	dataList = [],
	dataHeader = [],
	dataAccessor = [],
	viewHandleClick,
	setSelectedReference,
}) {
	const [currentPage, setCurrentPage] = useState(1);
	const [activeRowId, setActiveRowId] = useState(null);
	const itemsPerPage = 10;

	const columns = React.useMemo(
		() =>
			dataHeader.map((header, index) => ({
				Header: header,
				accessor: dataAccessor[index],
			})),
		[dataHeader, dataAccessor]
	);

	const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
		useTable({ columns, data: dataList });

	const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
	const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
	const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

	const totalPages = Math.ceil(rows.length / itemsPerPage);
	const isLastPage = currentPage === totalPages;

	const paginate = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setCurrentPage(pageNumber);
		}
	};

	const handleRowClick = (rowData) => {
		setSelectedReference(rowData); // Pass the clicked row data to the setSelectedEmployee function
		setActiveRowId(rowData.id);
	};

	return (
		<div>
			<table {...getTableProps()} className='border-collapse'>
				<thead>
					{headerGroups.map((headerGroup) => (
						<tr {...headerGroup.getHeaderGroupProps()}>
							{headerGroup.headers.map((column) => (
								<th {...column.getHeaderProps()}>{column.render("Header")}</th>
							))}
						</tr>
					))}
				</thead>
				<tbody {...getTableBodyProps()}>
					{dataList.length <= 0 && (
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center" }}>
								No data to display
							</td>
						</tr>
					)}
					{currentItems.map((row) => {
						prepareRow(row);
						return (
							<tr
								key={row.original.id}
								{...row.getRowProps()}
								onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
								className={row.original.id === activeRowId ? "active" : ""}
							>
								{row.cells.map((cell) =>
									SetInfo(
										cell.render("Cell").props.column.Header,
										cell,
										viewHandleClick
									)
								)}
							</tr>
						);
					})}
				</tbody>
			</table>
			{rows.length > itemsPerPage ? (
				<div>
					<div
						className="table-page row"
						style={{
							alignItems: "center",
							justifyContent: "end",
							padding: "20px 0 0 0",
						}}
					>
						<button
							className="prev row"
							onClick={() => paginate(1)}
							disabled={currentPage === 1}
							style={{
								visibility: currentPage === 1 ? "hidden" : "visible",
								marginRight: "5px",
								height: "26px",
							}}
						>
							&lt;&lt;
						</button>
						<button
							className="prev row"
							onClick={() => paginate(currentPage - 1)}
							disabled={currentPage === 1}
							style={{
								visibility: currentPage === 1 ? "hidden" : "visible",
								marginRight: "5px",
								height: "26px",
							}}
						>
							<NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
						</button>
						<button
							className="next row"
							onClick={() => paginate(currentPage + 1)}
							disabled={indexOfLastItem >= rows.length}
							style={{
								visibility:
									rows.length > itemsPerPage && !isLastPage
										? "visible"
										: "hidden",
								marginRight: "5px",
								height: "26px",
							}}
						>
							NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
						</button>
						<button
							className="next row"
							onClick={() => paginate(totalPages)}
							disabled={indexOfLastItem >= rows.length}
							style={{
								visibility:
									rows.length > itemsPerPage && !isLastPage
										? "visible"
										: "hidden",
								height: "26px",
							}}
						>
							&gt;&gt;
						</button>
					</div>
					<div
						style={{ textAlign: "center" }}
					>{`${currentPage}/${totalPages}`}</div>
				</div>
			) : (
				<></>
			)}
		</div>
	);
}